module.exports = __webpack_public_path__ + "media/images/plans/dinner/occation-2-58af05c69fea5b01e02614056391f074.jpg";